
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'FaqSection',
  props: {
    faqs: {
      type: Array,
      required: true,
    },
  },
});
